<template>
  <div
    style="text-align: left; line-height: 27px; font-size: 16px; color: black;  height: calc(100vh - 130px); overflow-y: auto "
    class="aaa">
    <div style=" padding: 30px; background-color: white;">
      <p> 本着在实验中充分激发学生算法学习兴趣、训练计算思维、培养解决复杂问 题的实践创新能力， 将学生培养成“能 Python 编程、会 Python 编程、编好 Python
        程序”的复合型卓越人才的目标。将财经作为数据可视化背景下算法学习中的重 要载体，使学生准确掌握动态规划算法并综合应用于解决现实生活中问题，激发 学生学习兴趣，提高编程能力。具体实验教学目标如下：</p>
      <p style="font-weight: bolder">1. 掌握 Python 语言中函数之间参数值传递和引用传递的差异</p>
      <p>在使用 Python 语言进行程序编写时， 函数的调用是非常普遍的。函数的调用 又可分为无参调用和有参调用，通常调用函数时，如果没有传递参数，则会使用 默认参数，叫做无参调用；需要将一个或多个参数传递至函数内部进行相关的计
        算操作，就是有参调用。从参数的类型来区分，又分为位置参数、关键字参数、 缺省参数、不定长参数、可变参数和不可变参数等。本实验平台重点聚焦于 Python 语言程序设计中最常用的有参调用中的值传递和引用传递，具体建模分析这 2
        种 传递方式的区别，和不同的传递方式对结果会产生不同的影响，帮助学生深入理 解和掌握这 2 种参数传递方式。</p>
      <p>值传递：值传递通常就是拷贝参数的值，然后传递给函数里的新变量，这样，原变量和新变量之间互相独立，互不影响。具体而言，在使用值传递时，形参和实参是两个独立的变量，各自在内存中拥有不同的内存空间，系统将实参的值进
        行拷贝然后赋值给形参，在被调函数中修改形参的值不会影响实参本身；</p>
      <p>
        引用传递：引用传递通常是指把参数的引用传给新的变量，这样，原变量和新变量就会指向同一块内存地址。如果改变了其中任何一个变量的值，那么另外一个变量也会相应地随之改变。使用引用传递时，形参是系统给实参起的一个别名，形参代表的就是实参本身，因而系统不会给形参再额外分配内存，并且在被调函数中修改形参的值将会改变实参本身。
      </p>
      <p>完成实验后，学生应能够快速区分和自主选择参数传递方式，了解它们之间 的差异及其背后的原理，并在实际代码编写过程中熟练使用每种参数传递方法。</p>
      <p style="font-weight: bolder">2. 掌握 Python 语言中函数之间参数传递的顺序和机制</p>
      <p>函数时一段具有特定功能的、可重用的语句组，用函数名来表示并通过函数 名进行功能调用。函数定义中参数列表里面的参数是形式参数，简称为“形参”； 而实际运算需要传递进去的参数叫实际参数，简称为“实参”。在函数调用时， 系
        统一般会执行以下 4 个步骤：</p>
      <p style="text-indent: 4em;">（1）调用程序在调用处暂停执行；</p>
      <p style="text-indent: 4em;">（2）在调用时将实参复制给函数的形参；</p>
      <p style="text-indent: 4em;">（3）执行函数体语句；</p>
      <p style="text-indent: 4em;">（4）函数调用结束给出返回值，程序回到调用前的暂停处继续执行。</p>
      <p>从计算机系统内部的角度来看，程序执行函数调用时，首先会将被调函数加 载到栈顶，然后从左到右依次检查被调函数的每一个参数项，并且依次对被调函
        数的形参进行初始化赋值。初始化赋值时，根据形参的数据类型不同，赋值方式也不同。</p>
      <p>对于值传递，系统会将实参的值进行拷贝，然后赋值给形参；</p>
      <p>
        对于引用传递，形参即代表实参本身，不再额外分配内存，形参会使用实参 的内存地址进行初始化赋值。
      </p>
      <p>
        完成实验后，学生应了解被调函数函数加载的位置，掌握初始化形参变量时 参数赋值的过程及其顺序，能够设计代码来验证形参初始化规则。
      </p>
      <p style="font-weight: bolder">3. 掌握 Python 程序运行时的内存管理与分配机制和原理</p>
      <p>
        Python 中， 一切皆为对象， 每个对象由：标识(identity)、类型(type)、值 (value)组成。对象的本质就是一个内存块， 拥有特定的值， 支持特定类型的相关 操作。在 Python
        中，变量也称为对象的引用。因为， 变量存储的就是对象的地址， 变量通过地址引用了“对象”。变量位于栈内存；对象位于堆内存。 函数中定义的 几个基本类型的变量和对象的引用变量被分配给函数的堆栈内存，当在代码块中 定义变量时，
        Python 在堆栈中为该变量分配内存空间。一个函数被调用时， 系统 会为其形参和局部变量分配内存，分配的内存都有其对应的作用域及寿命，作用 域是指在哪一区域中该变量是有效的，寿命是指在什么时候该变量所分配的内存
        被系统回收掉。此外， Python 程序设计中的重难知识点——深拷贝与浅拷贝问题， 也涉及内存管理分配机制与原理。
        完成实验后，学生应熟悉 Python 语言中函数的参数和变量在内存中存放的方 式，掌握参数和变量的作用域及其寿命，重点掌握深拷贝与浅拷贝的区别与应用。
      </p>
      <p style="font-weight: bolder">4. 提高学生自主学习的能力</p>
      <p>Python 语言可视化执行虚拟仿真实验教学平台能够将 Python 程序的执行过 程可视化， 从计算机内部揭示程序运行的原理和过程， 能够更加直观地显示程序 执行的逻辑，帮助学生发现程序中的错误。当学生编写的程序出现
        Bug 时，可以 借助本平台来可视化执行以探索其中的原因， 帮助学生理解 Python 语言中的知识 点，提高学生主动探索学习的能力。
      </p></div>
  </div>
</template>
<script>
  import Sortable from 'sortablejs'

  export default {
    data() {
      return {
        col: [
          {
            label: '顺序号',
            prop: 'seqNum'
          },
          {
            label: '图书名称',
            prop: 'bookName'
          }
        ],
        dropCol: [
          {
            label: '顺序号',
            prop: 'seqNum'
          },
          {
            label: '图书名称',
            prop: 'bookName'
          }
        ],
        tableData: [
          {
            id: '1',
            seqNum: '2016-05-02',
            bookName: '赵'
          },
          {
            id: '2',
            seqNum: '2016-05-02',
            bookName: '钱'
          },
          {
            id: '3',
            seqNum: '2016-05-02',
            bookName: '孙'
          },
          {
            id: '4',
            seqNum: '2016-05-02',
            bookName: '李'
          },
        ]
      }
    },
    mounted() {
      this.rowDrop()
      this.columnDrop()
    },
    methods: {
      //行拖拽
      rowDrop() {
        const tbody = document.querySelector('.aaa .el-table__body-wrapper tbody')
        const _this = this
        Sortable.create(tbody, {
          onEnd({newIndex, oldIndex}) {
            const currRow = _this.tableData.splice(oldIndex, 1)[0]
            _this.tableData.splice(newIndex, 0, currRow)
          }
        })
      },
      //列拖拽
      columnDrop() {
        const wrapperTr = document.querySelector('.aaa .el-table__header-wrapper tr')
        this.sortable = Sortable.create(wrapperTr, {
          animation: 180,
          delay: 0,
          onEnd: evt => {
            const oldItem = this.dropCol[evt.oldIndex]
            this.dropCol.splice(evt.oldIndex, 1)
            this.dropCol.splice(evt.newIndex, 0, oldItem)
          }
        })
      }
    }
  }
</script>
<style scoped>

  p {
    text-indent: 2em;
  }

</style>



// WEBPACK FOOTER //
// src/components/dzs/dzsgl.vue